import { Card } from "@excalidraw/excalidraw/components/Card";
import { ToolButton } from "@excalidraw/excalidraw/components/ToolButton";
import { LoadIcon } from "@excalidraw/excalidraw/components/icons";

import { appJotaiStore } from "../../app-jotai";
import { saveCurrentCloudDoc } from "../cloudActions";
import { getCurrentCloudDoc } from "../currentDoc";
import { saveToCloudDialogAtom } from "../dialogState";

/**
 * "Save to cloud" card shown as the third option in the export ("Save to...")
 * dialog, alongside Save to disk and Export to link. If the drawing is already
 * a cloud document it saves a new version; otherwise it opens the name prompt.
 */
export const ExportToCloudCard = ({
  onError,
  onSuccess,
}: {
  onError: (error: Error) => void;
  onSuccess: () => void;
}) => {
  return (
    <Card color="primary">
      <div className="Card-icon">{LoadIcon}</div>
      <h2>Save to cloud</h2>
      <div className="Card-details">
        Save this drawing to your cloud workspace so you can open it later from
        any device.
      </div>
      <ToolButton
        className="Card-button"
        type="button"
        title="Save to cloud"
        aria-label="Save to cloud"
        showAriaLabel={true}
        onClick={async () => {
          try {
            if (getCurrentCloudDoc()) {
              // Already a cloud doc — save a new version directly.
              await saveCurrentCloudDoc("tagged");
            } else {
              // New drawing — open the name/folder prompt dialog.
              appJotaiStore.set(saveToCloudDialogAtom, {
                isOpen: true,
                mode: "save",
              });
            }
            onSuccess();
          } catch (error: any) {
            onError(
              error instanceof Error
                ? error
                : new Error("Save to cloud failed"),
            );
          }
        }}
      />
    </Card>
  );
};
